function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { DEFAULTS, registerButton, AbstractButton, AbstractPlugin, PSVError, events as events_exports$1, utils as utils_exports, TypedEvent } from '../core/index.module.js';
import { StereoCamera, Vector2 } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.StereoPlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  StereoUpdatedEvent: function StereoUpdatedEvent() {
    return _StereoUpdatedEvent2;
  }
});
var _StereoUpdatedEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_StereoUpdatedEvent, _TypedEvent);
  var _super = _createSuper(_StereoUpdatedEvent);
  function _StereoUpdatedEvent(stereoEnabled) {
    var _this;
    _classCallCheck(this, _StereoUpdatedEvent);
    _this = _super.call(this, _StereoUpdatedEvent.type);
    _this.stereoEnabled = stereoEnabled;
    return _this;
  }
  return _createClass(_StereoUpdatedEvent);
}(TypedEvent);
var _StereoUpdatedEvent2 = _StereoUpdatedEvent;
_StereoUpdatedEvent2.type = "stereo-updated";

// src/icons/stereo.svg
var stereo_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -2 16 16"><path fill="currentColor" d="M13.104 0H2.896C2.332 0 1 .392 1 .875h14C15 .392 13.668 0 13.104 0zM15 1H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3.534a2 2 0 0 0 1.821-1.172l1.19-2.618a.5.5 0 0 1 .91 0l1.19 2.618A2 2 0 0 0 11.466 11H15a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM4 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/><!--Created by Idev\xE3 Batista from the Noun Project--></svg>';

// src/StereoButton.ts
var StereoButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(StereoButton, _AbstractButton);
  var _super2 = _createSuper(StereoButton);
  function StereoButton(navbar) {
    var _this2;
    _classCallCheck(this, StereoButton);
    _this2 = _super2.call(this, navbar, {
      className: "psv-stereo-button",
      icon: stereo_default,
      hoverScale: true,
      collapsable: true,
      tabbable: true
    });
    _this2.plugin = _this2.viewer.getPlugin("stereo");
    if (_this2.plugin) {
      _this2.plugin.addEventListener(_StereoUpdatedEvent2.type, _assertThisInitialized(_this2));
    }
    return _this2;
  }
  _createClass(StereoButton, [{
    key: "destroy",
    value: function destroy() {
      if (this.plugin) {
        this.plugin.removeEventListener(_StereoUpdatedEvent2.type, this);
      }
      _get(_getPrototypeOf(StereoButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !this.plugin ? false : {
        initial: false,
        promise: this.plugin.isSupported
      };
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _StereoUpdatedEvent2) {
        this.toggleActive(e.stereoEnabled);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggle();
    }
  }]);
  return StereoButton;
}(AbstractButton);
StereoButton.id = "stereo";

// src/icons/mobile-rotate.svg
var mobile_rotate_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66.7 19a14 14 0 0 1 13.8 12.1l-3.9-2.7c-.5-.3-1.1-.2-1.4.3-.3.5-.2 1.1.3 1.4l5.7 3.9.6.2c.3 0 .6-.2.8-.4l3.9-5.7c.3-.5.2-1.1-.3-1.4-.5-.3-1.1-.2-1.4.3l-2.4 3.5A16 16 0 0 0 66.7 17c-.6 0-1 .4-1 1s.4 1 1 1zM25 15h10c.6 0 1-.4 1-1s-.4-1-1-1H25c-.6 0-1 .4-1 1s.4 1 1 1zm-6.9 30H16l-2 .2a1 1 0 0 0-.8 1.2c.1.5.5.8 1 .8h.2l1.7-.2h2.1c.6 0 1-.4 1-1s-.5-1-1.1-1zm10 0h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zM84 45H55V16A11 11 0 0 0 44 5H16A11 11 0 0 0 5 16v68a11 11 0 0 0 11 11h68a11 11 0 0 0 11-11V56a11 11 0 0 0-11-11zM16 93c-5 0-9-4-9-9V53.2c.3-.1.6-.3.7-.6a9.8 9.8 0 0 1 2-3c.4-.4.4-1 0-1.4a1 1 0 0 0-1.4 0l-1.2 1.5V16c0-5 4-9 9-9h28c5 0 9 4 9 9v68c0 5-4 9-9 9H16zm77-9c0 5-4 9-9 9H50.3c2.8-2 4.7-5.3 4.7-9V47h29c5 0 9 4 9 9v28zM38.1 45h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.5-1-1-1zm9.9 0h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zm38 19c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1s1-.4 1-1V65c0-.6-.4-1-1-1z"/><!--Created by Anthony Bresset from the Noun Project--></svg>';
var StereoEffect = /*#__PURE__*/_createClass(function StereoEffect(renderer) {
  _classCallCheck(this, StereoEffect);
  var _stereo = new StereoCamera();
  _stereo.aspect = 0.5;
  var size = new Vector2();
  this.setEyeSeparation = function (eyeSep) {
    _stereo.eyeSep = eyeSep;
  };
  this.setSize = function (width, height) {
    renderer.setSize(width, height);
  };
  this.render = function (scene, camera) {
    scene.updateMatrixWorld();
    if (camera.parent === null) camera.updateMatrixWorld();
    _stereo.update(camera);
    renderer.getSize(size);
    if (renderer.autoClear) renderer.clear();
    renderer.setScissorTest(true);
    renderer.setScissor(0, 0, size.width / 2, size.height);
    renderer.setViewport(0, 0, size.width / 2, size.height);
    renderer.render(scene, _stereo.cameraL);
    renderer.setScissor(size.width / 2, 0, size.width / 2, size.height);
    renderer.setViewport(size.width / 2, 0, size.width / 2, size.height);
    renderer.render(scene, _stereo.cameraR);
    renderer.setScissorTest(false);
  };
});

// src/StereoPlugin.ts
var ID_OVERLAY_PLEASE_ROTATE = "pleaseRotate";
var StereoPlugin = /*#__PURE__*/function (_AbstractPlugin) {
  _inherits(StereoPlugin, _AbstractPlugin);
  var _super3 = _createSuper(StereoPlugin);
  function StereoPlugin(viewer) {
    var _this3;
    _classCallCheck(this, StereoPlugin);
    _this3 = _super3.call(this, viewer);
    _this3.state = {
      enabled: false,
      wakeLock: null
    };
    return _this3;
  }
  _createClass(StereoPlugin, [{
    key: "isSupported",
    get: function get() {
      return this.gyroscope.isSupported();
    }
  }, {
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(StereoPlugin.prototype), "init", this).call(this);
      this.markers = this.viewer.getPlugin("markers");
      this.compass = this.viewer.getPlugin("compass");
      this.gyroscope = this.viewer.getPlugin("gyroscope");
      if (!this.gyroscope) {
        throw new PSVError("Stereo plugin requires the Gyroscope plugin");
      }
      this.viewer.addEventListener(events_exports$1.StopAllEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ClickEvent.type, this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.StopAllEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ClickEvent.type, this);
      this.stop();
      delete this.markers;
      delete this.compass;
      delete this.gyroscope;
      _get(_getPrototypeOf(StereoPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.StopAllEvent || e instanceof events_exports$1.ClickEvent) {
        this.stop();
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.state.enabled;
    }
  }, {
    key: "start",
    value: function start() {
      var _this4 = this;
      this.viewer.enterFullscreen();
      this.__startWakelock();
      this.__lockOrientation();
      return this.gyroscope.start().then(function () {
        var _this4$markers, _this4$compass;
        _this4.viewer.renderer.setCustomRenderer(function (renderer) {
          return new StereoEffect(renderer);
        });
        _this4.state.enabled = true;
        (_this4$markers = _this4.markers) === null || _this4$markers === void 0 ? void 0 : _this4$markers.hideAllMarkers();
        (_this4$compass = _this4.compass) === null || _this4$compass === void 0 ? void 0 : _this4$compass.hide();
        _this4.viewer.navbar.hide();
        _this4.viewer.panel.hide();
        _this4.dispatchEvent(new _StereoUpdatedEvent2(true));
        _this4.viewer.notification.show({
          content: _this4.viewer.config.lang.stereoNotification,
          timeout: 3e3
        });
      }, function () {
        _this4.__unlockOrientation();
        _this4.__stopWakelock();
        _this4.viewer.exitFullscreen();
        return Promise.reject();
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.isEnabled()) {
        var _this$markers, _this$compass;
        this.viewer.renderer.setCustomRenderer(null);
        this.state.enabled = false;
        (_this$markers = this.markers) === null || _this$markers === void 0 ? void 0 : _this$markers.showAllMarkers();
        (_this$compass = this.compass) === null || _this$compass === void 0 ? void 0 : _this$compass.show();
        this.viewer.navbar.show();
        this.__unlockOrientation();
        this.__stopWakelock();
        this.viewer.exitFullscreen();
        this.gyroscope.stop();
        this.dispatchEvent(new _StereoUpdatedEvent2(false));
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isEnabled()) {
        this.stop();
      } else {
        this.start();
      }
    }
  }, {
    key: "__startWakelock",
    value: function __startWakelock() {
      var _this5 = this;
      if ("wakeLock" in navigator) {
        navigator.wakeLock.request("screen").then(function (wakeLock) {
          _this5.state.wakeLock = wakeLock;
        })["catch"](function () {
          return utils_exports.logWarn("Cannot acquire WakeLock");
        });
      } else {
        utils_exports.logWarn("WakeLock is not available");
      }
    }
  }, {
    key: "__stopWakelock",
    value: function __stopWakelock() {
      if (this.state.wakeLock) {
        this.state.wakeLock.release();
        this.state.wakeLock = null;
      }
    }
  }, {
    key: "__lockOrientation",
    value: function __lockOrientation() {
      var _this6 = this,
        _window$screen;
      var displayRotateMessageTimeout;
      var displayRotateMessage = function displayRotateMessage() {
        if (window.innerHeight > window.innerWidth) {
          _this6.viewer.overlay.show({
            id: ID_OVERLAY_PLEASE_ROTATE,
            image: mobile_rotate_default,
            title: _this6.viewer.config.lang.pleaseRotate,
            text: _this6.viewer.config.lang.tapToContinue
          });
        }
        if (displayRotateMessageTimeout) {
          clearTimeout(displayRotateMessageTimeout);
          displayRotateMessageTimeout = null;
        }
      };
      if ((_window$screen = window.screen) !== null && _window$screen !== void 0 && _window$screen.orientation) {
        window.screen.orientation.lock("landscape").then(null, function () {
          return displayRotateMessage();
        });
        displayRotateMessageTimeout = setTimeout(function () {
          return displayRotateMessage();
        }, 500);
      } else {
        displayRotateMessage();
      }
    }
  }, {
    key: "__unlockOrientation",
    value: function __unlockOrientation() {
      var _window$screen2;
      if ((_window$screen2 = window.screen) !== null && _window$screen2 !== void 0 && _window$screen2.orientation) {
        window.screen.orientation.unlock();
      } else {
        this.viewer.overlay.hide(ID_OVERLAY_PLEASE_ROTATE);
      }
    }
  }]);
  return StereoPlugin;
}(AbstractPlugin);
StereoPlugin.id = "stereo";

// src/index.ts
DEFAULTS.lang[StereoButton.id] = "Stereo view";
registerButton(StereoButton, "caption:right");
DEFAULTS.lang.stereoNotification = "Tap anywhere to exit stereo view.";
DEFAULTS.lang.pleaseRotate = "Please rotate your device";
DEFAULTS.lang.tapToContinue = "(or tap to continue)";
export { StereoPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
